// test-tasks
import DefaultLayout from '@/layouts/DefaultLayout.vue'
// lesson-tasks
import LessonsTasksLists from '@/pages/bank/lesson-tasks/list/LessonTasksList.vue'
import LessonTaskCreationPage from '@/pages/bank/lesson-tasks/create/TaskCreationPage.vue'
import LessonTaskEditionPage from '@/pages/bank/lesson-tasks/edit/TaskEditionPage.vue'

export default [
  {
    name: 'bank',
    path: '/bank',
    redirect: { name: 'test-tasks-list' },
    component: DefaultLayout,
    children: [
      {
        name: 'lesson-tasks',
        path: 'lesson-tasks',
        component: DefaultLayout,
        redirect: { name: 'lesson-tasks-create' },
        children: [
          {
            name: 'lesson-tasks-list',
            path: 'list',
            component: LessonsTasksLists,
            meta: {
              title: 'Задания для уроков - Школа Летово',
            },
          },
          {
            name: 'lesson-tasks-create',
            path: 'create',
            component: LessonTaskCreationPage,
            meta: {
              title: 'Создание задания для уроков - Школа Летово',
            },
          },
          {
            name: 'lesson-tasks-edit',
            path: 'create/:id',
            component: LessonTaskEditionPage,
            meta: {
              title: 'Редактирование задания для уроков - Школа Летово',
            },
          },
        ],
      },
    ],
  },
]
